<template>
  <div>
    <nav class="relative z-0 inline-flex shadow rounded select-none">
      <a
        class="cursor-pointer relative inline-flex items-center px-2 py-2
        rounded-l-md border border-gray-300 bg-white text-sm leading-5
        font-medium text-gray-500 hover:text-gray-400 focus:z-10
        focus:outline-none focus:border-blue-300 focus:shadow-outline-blue
         active:bg-gray-100 active:text-gray-500 transition ease-in-out
         duration-150"
        aria-label="Previous"
        @click="previous()"
      >
        <svg
          class="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0
            01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </a>
      <a
        :class="paginationTriggers[0] === (pageIndex) ? 'bg-gray-100' : '' "
        class="cursor-pointer hover:bg-gray-50 -ml-px relative inline-flex
        items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5
        font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none
         focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100
         active:text-gray-700 transition ease-in-out duration-150"
        @click="changeIndex(paginationTriggers[0])"
      >
        {{ paginationTriggers[0] }}
      </a>
      <a
        v-if="totalPages >= 2"
        :class="paginationTriggers[1] === (pageIndex) ? 'bg-gray-100' : '' "
        class="cursor-pointer hover:bg-gray-50 -ml-px relative inline-flex
        items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5
        font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none
         focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100
         active:text-gray-700 transition ease-in-out duration-150"
        @click="changeIndex(paginationTriggers[1])"
      >
        {{ paginationTriggers[1] }}
      </a>
      <a
        v-if="totalPages >= 3"
        :class="paginationTriggers[2] === (pageIndex) ? 'bg-gray-100' : '' "
        class="cursor-pointer hover:bg-gray-50 hidden md:inline-flex -ml-px
        relative items-center px-4 py-2 border border-gray-300 bg-white
        text-sm leading-5 font-medium text-gray-700 hover:text-gray-500
        focus:z-10 focus:outline-none focus:border-blue-300
        focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700
        transition ease-in-out duration-150"
        @click="changeIndex(paginationTriggers[2])"
      >
        {{ paginationTriggers[2] }}
      </a>
      <span
        v-if="totalPages >= 4"
        :class="paginationTriggers[3] === (pageIndex) ? 'bg-gray-100' : '' "
        class="cursor-pointer hover:bg-gray-50 -ml-px relative inline-flex
        items-center px-4 py-2 border border-gray-300 bg-white text-sm
        leading-5 font-medium text-gray-700"
        @click="changeIndex(paginationTriggers[3])"
      >
        {{ paginationTriggers[3] }}
      </span>
      <a
        v-if="totalPages >= 5"
        :class="paginationTriggers[4] === (pageIndex) ? 'bg-gray-100' : '' "
        class="cursor-pointer hover:bg-gray-50 hidden md:inline-flex -ml-px
        relative items-center px-4 py-2 border border-gray-300 bg-white
        text-sm leading-5 font-medium text-gray-700 hover:text-gray-500
        focus:z-10 focus:outline-none focus:border-blue-300
        focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700
        transition ease-in-out duration-150"
        @click="changeIndex(paginationTriggers[4])"
      >
        {{ paginationTriggers[4] }}
      </a>
      <a
        v-if="totalPages >= 6"
        :class="paginationTriggers[5] === (pageIndex) ? 'bg-gray-100' : '' "
        class="cursor-pointer hover:bg-gray-50 -ml-px relative inline-flex items-center
        px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium
         text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none
         focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100
         active:text-gray-700 transition ease-in-out duration-150"
        @click="changeIndex(paginationTriggers[5])"
      >
        {{ paginationTriggers[5] }}
      </a>
      <a
        v-if="totalPages >= 7"
        :class="paginationTriggers[6] === (pageIndex) ? 'bg-gray-100' : '' "
        class="cursor-pointer hover:bg-gray-50 -ml-px relative inline-flex
        items-center px-4 py-2 border border-gray-300 bg-white text-sm
        leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10
        focus:outline-none focus:border-blue-300 focus:shadow-outline-blue
        active:bg-gray-100 active:text-gray-700 transition ease-in-out
        duration-150"
        @click="changeIndex(paginationTriggers[6])"
      >
        {{ paginationTriggers[6] }}
      </a>
      <a
        class="cursor-pointer -ml-px relative inline-flex items-center px-2 py-2
        rounded-r-md border border-gray-300 bg-white text-sm leading-5
        font-medium text-gray-500 hover:text-gray-400 focus:z-10
        focus:outline-none focus:border-blue-300 focus:shadow-outline-blue
         active:bg-gray-100 active:text-gray-500 transition ease-in-out
         duration-150"
        aria-label="Next"
        @click="next()"
      >
        <svg
          class="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0
            011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </a>
    </nav>
  </div>
</template>

<script>
export default {

  props: {
    pageIndex: {
      type: Number,
      default: 0,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    visiblePagesCount: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {

    };
  },

  computed: {
    paginationTriggers() {
      const currentPage = this.pageIndex;
      const pageCount = this.totalPages;
      const { visiblePagesCount } = this;
      const visiblePagesThreshold = (visiblePagesCount - 1) / 2;
      const pagintationTriggersArray = Array(this.visiblePagesCount - 1).fill(
        0,
      );

      if (currentPage <= visiblePagesThreshold + 1) {
        pagintationTriggersArray[0] = 1;
        const pagintationTriggers = pagintationTriggersArray.map(
          (paginationTrigger, index) => pagintationTriggersArray[0] + index,
        );

        pagintationTriggers.push(pageCount);

        return pagintationTriggers;
      }

      if (currentPage >= pageCount - visiblePagesThreshold + 1) {
        const pagintationTriggers = pagintationTriggersArray.map(
          (paginationTrigger, index) => pageCount - index,
        );

        pagintationTriggers.reverse().unshift(1);

        return pagintationTriggers;
      }

      pagintationTriggersArray[0] = currentPage - visiblePagesThreshold + 1;
      const pagintationTriggers = pagintationTriggersArray.map(
        (paginationTrigger, index) => pagintationTriggersArray[0] + index,
      );

      pagintationTriggers.unshift(1);
      pagintationTriggers[pagintationTriggers.length - 1] = pageCount;

      return pagintationTriggers;
    },

  },

  methods: {
    changeIndex(index) {
      this.$emit('click', index);
    },
  },
};
</script>
